module.exports = __webpack_public_path__ + "media/Acting_Dialogue_Dying.726dda49.mp3";